/**
 * WorkspaceShell — the focus-mode container that replaced the old fixed
 * two-panel layout. One mode is shown full-width at a time; the mode bar (and
 * the copilot's navigate tool) switch between them. The "what's next" guidance
 * now lives in the Copilot panel on the right (not a banner at the top). State
 * comes from WorkspaceContext (owned by App.js).
 */

import React from 'react';
import { useWorkspace } from './WorkspaceContext';
import ModeRail from './ModeRail';
import BuildMode from './BuildMode';
import InventoryMode from './InventoryMode';
import ResultsMode from './ResultsMode';
import CompareMode from './CompareMode';
import TemplateUpdateNotice from './TemplateUpdateNotice';
import './Workspace.css';

export default function WorkspaceShell() {
  const { workspaceMode } = useWorkspace();

  return (
    <div className="workspace-layout">
      <ModeRail />
      <div className="workspace">
        <TemplateUpdateNotice />
        <div className="workspace-body">
          {workspaceMode === 'inventory' ? <InventoryMode />
            : workspaceMode === 'results' ? <ResultsMode />
            : workspaceMode === 'compare' ? <CompareMode />
            : <BuildMode />}
        </div>
      </div>
    </div>
  );
}
